package com.hyperether.goodjob.util

sealed class FileType {
    object Image : FileType()
    object PDF : FileType()
    object Unknown : FileType()
}
